<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-autocomplete v-model="queryForm.vehicle_type" :items="vehicle_types" label="车辆类型"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-text-field v-model="queryForm.vehicle_number" label="车牌号" dense outlined clearable>
        </v-text-field>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-text-field v-model="queryForm.vehicle_gnumber" label="挂箱号" dense outlined clearable>
        </v-text-field>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-autocomplete v-model="queryForm.postlineid" :items="postlines" label="线路"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-text-field v-model="queryForm.location" label="位置" dense outlined clearable>
        </v-text-field>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <a-space>
          <v-btn @click="getdata()" color="primary" dark tile>
            <v-icon small>mdi-magnify</v-icon>查询
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <a-tabs v-model="queryForm.own_type" size="small" @change="(v) => getdata()">
      <a-tab-pane :key="0" tab="全部"></a-tab-pane>
      <a-tab-pane :key="1" tab="自有车"></a-tab-pane>
      <a-tab-pane :key="3" tab="包车"></a-tab-pane>
      <a-tab-pane :key="2" tab="临调车"></a-tab-pane>
    </a-tabs>
    <v-card tile class="mt-2">
      <v-data-table :headers="headers" :items="list" :items-per-page="limit" no-data-text="无数据" hide-default-footer
        disable-sort fixed-header :height="height">
        <template v-slot:item.index="{ index }">
          {{ index + 1 }}
        </template>
        <template v-slot:item.vehicle_gnumber="{ item }">
          <span v-if="item.bind_vehicle_gnumber" class="error--text">
            {{ item.bind_vehicle_gnumber }}
          </span>
          <span v-else>{{ item.vehicle_gnumber }}</span>
        </template>
        <template v-slot:item.postroute="{ item }">
          <span v-if="item.current_postline" class="error--text">
            {{ item.current_postline }}
          </span>
          <span v-else> {{ item.postroute }} </span>
        </template>
        <template v-slot:item.state_desc="{ item }">
          <p v-if="item.current_state_desc" class="error--text">
            {{ item.current_state_desc }}
          </p>
          <p v-else>{{ item.state_desc }}</p>
          <p v-if="item.current_state_time" class="error--text">
            {{ item.current_state_time }}
          </p>
          <p v-else>{{ item.state_time }}</p>
        </template>
        <template v-slot:item.location="{ item }">
          <p>{{ item.location.title }}</p>
          <p>{{ item.location.address }}</p>
          <p>{{ item.location_time }}</p>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "RunningTable",
  data() {
    return {
      queryForm: {
        vehicle_type: null,
        own_type: 1,
        vehicle_number: "",
        vehicle_gnumber: "",
        postlineid: null,
        location: "",
      },
      vehicle_types: [],
      own_types: [],
      postlines: [],
      headers: [],
      list: [],
      // page: 1,
      // limit: 20,
      // length: 0,
      // count: 0,
      height: 600,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  watch: {
    // page() {
    //   this.getdata();
    // },
    // limit() {
    //   if (this.page !== 1) this.page = 1;
    //   else this.getdata();
    // },
  },
  mounted() {
    this.height = window.innerHeight - 220;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 220;
    };
    this.queryForm = {
      vehicle_type: null,
      own_type: 1,
      vehicle_number: "",
      vehicle_gnumber: "",
      postlineid: null,
      location: "",
    };
    this.list = [];
    // this.page = 1;
    // this.length = 0;
    // this.count = 0;
  },
  activated() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/runningtable/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          // this.length = res.data.length;
          // this.count = res.data.count;
          // if (this.length > 0 && this.page > this.length) this.page = 1;
          this.vehicle_types = res.data.vehicle_types;
          this.own_types = res.data.own_types;
          this.postlines = res.data.postlines;
          // 自有车(1) / 包车(3) 两个 tab 增加"司机名称"、"司机电话"两列
          // 字段名占位：driver_name / driver_phone；后端联调后如不同直接改
          const driverColumns = (this.queryForm.own_type === 1 || this.queryForm.own_type === 3)
            ? [
              { text: "司机名称", value: "driver_name", width: 100, align: "center" },
              { text: "司机电话", value: "driver_phone", width: 130, align: "center" },
            ]
            : [];
          this.headers = [
            { text: "序号", value: "index", width: 80, align: "center" },
            { text: "车牌号", value: "vehicle_number", width: 100, align: "center" },
            { text: "挂箱号", value: "vehicle_gnumber", width: 100, align: "center" },
            { text: "车辆类型", value: "vehicle_type", width: 100, align: "center" },
            ...driverColumns,
            { text: "车辆属性", value: "own_type_name", width: 100, align: "center" },
            { text: "执行邮路", value: "postroute", width: 120, align: "center" },

            { text: "当前状态", value: "state_desc", width: 160, align: "center" },
            { text: "当前位置", value: "location", width: 150, align: "center" },
            ...(res.data.headers || []),
          ];
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>